import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgBsModalServiceModule } from 'ng-bs-modal-service';
import { NgBsToastServiceModule } from 'ng-bs-toast-service';
import { NgGenerateTableModule } from 'ng-generate-table';
import { NgxCurrencyDirective } from 'ngx-currency';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { NgSelectModule } from '@ng-select/ng-select';
import { BreadcrumbComponent, PaginationComponent } from './components';
import { SafeHtmlPipe, TranslatePipe } from './pipes';
import { AccessControlDirective } from './directives';

@NgModule({
    declarations: [
        BreadcrumbComponent,
        PaginationComponent,

        SafeHtmlPipe,
        TranslatePipe,

        AccessControlDirective,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgOptimizedImage,
        RouterModule,

        NgGenerateTableModule,
        NgBsModalServiceModule,
        NgBsToastServiceModule,
        NgSelectModule,

        NgxCurrencyDirective,
        NgxMaskDirective,

        NgxMaskPipe,
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgOptimizedImage,
        RouterModule,

        NgGenerateTableModule,
        NgBsModalServiceModule,
        NgBsToastServiceModule,
        NgSelectModule,

        BreadcrumbComponent,
        PaginationComponent,

        SafeHtmlPipe,
        TranslatePipe,
        NgxMaskPipe,

        NgxMaskDirective,
        AccessControlDirective,
        NgxCurrencyDirective,
    ],
    providers: [
        provideNgxMask(),
    ]
})
export class SharedModule { }
